<template>
    <section>
        <sy-baselist
                ref="main"
                :filters="filters"
                operateWidth="280"
                packUpBtn
                @beforeDelete="beforeDelete"
                @beforeAdd="beforeAdd"
                @onPackUp="onPackUp"
                editVue="business/Staff_Edit.vue"
                listUrl="server/system/Staff.ashx?cmd=GetStafList"
                deleteUrl="server/system/Staff.ashx?cmd=DeleteStaf"
        >
            <el-table-column prop="DeptName" label="部门" width="200" >
            </el-table-column>
            <el-table-column prop="FName" label="姓名" width="120" >
            </el-table-column>
              <el-table-column prop="FCode" label="工号" width="120" >
            </el-table-column>
            <el-table-column prop="FPhone" label="电话" width="130" >
            </el-table-column>
            <el-table-column prop="RoleName" label="角色" width="150" sortable="custom">
            </el-table-column> 
        </sy-baselist>
    </section>
</template>

<script>
    import util from '../../common/util'
    import mixin from '../../common/mixin'
    export default {
        mixins: [mixin],
        data(){
            return {
                deptRow:{},
                filters: [
                    {type: "string",name:"FName",text:"姓名", value: ""}
                ]
            }
        },
        methods:{
            _search(deptRow){
                this.deptRow = deptRow
                //this.$refs.main._search("","FDeptLabel like '" + deptRow.Label + "%'")
                this.$refs.main._search("","FDeptID="+deptRow.FID)
            },
            beforeDelete(row,r){
                if(row.FID<0) {
                    return r.error = "系统用户，不能删除";
                }
            },
            beforeAdd(row,r){
                if(this.deptRow && this.deptRow.FID){
                    row.FDeptID = this.deptRow.FID
                    row.FDeptLabel = this.deptRow.Label
                }
            },
            onPackUp(flag){
               this.$emit("onPackUp",flag)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/business/Staff.vue